import { fetchSolaris } from '../../api';
import { fetchData } from './dataActionsCreator';

export function fetchOptions() {
  const fetchFunction = async () => {
    const { options } = await fetchSolaris('onboarding/options');
    return {
      onboardingOptions: options,
    };
  };
  return fetchData(fetchFunction);
}




// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/onboardingActionsCreator.js